import { gql } from '@apollo/client/core';

export const initialLocalState = gql`
  query InitCacheStorage {
    commandes {
      data {
        id
      }
    }
  }
`;
